/**
 * 课程状态枚举
 */
export enum EnumActivityState {
  /** 报名未开始 */
  NotStarted = '报名未开始',
  /** 正在报名 */
  InProgress = '正在报名',
  /** 未开课 */
  NoClass = '未开课',
  /** 开课中 */
  InClass = '开课中',
  /** 已结课 */
  EndofClass = '已结课'
}

export enum EnumNewActivityState {
  /** 报名未开始 */
  NotStarted = '即将报名',
  /** 正在报名 */
  InProgress = '立即报名',
  /** 报名结束 */
  SignupEnd = '报名结束',
  /** 开课中 */
  InClass = '开课中',
  /** 已结课 */
  EndofClass = '已结课'
}

/**
 * 订单目标类型（101:单阶课，102:全阶课，201:活动，301:展览）
 * **/
export enum EnumOrderType {
  single = 101,

  full = 102,

  activity = 201,

  exhibition = 301
}

export enum EnumDetailPage {
  /** 入门 */
  Beginner = 'beginner',
  /** 初阶 */
  Junior = 'junior',
  /** 进阶 */
  Advanced = 'advanced',
  /** 高阶 */
  Senior = 'senior'
}

export enum EnumWelcomeAskCompType {
  NoBasic = 'no-basic',
  Uninsist = 'uninsist',
  HowXt = 'how-xt'
}

export enum EnumActivityBtnType {
  /** 已结课 */
  ClassEnd = 'class-end',
  /** 已报名,去上课 */
  GoClass = 'go-class',
  /** 开课中 */
  InClass = 'in-class',
  /** 报名结束 */
  SignupEnd = 'signup-end',
  /** 转报全阶 */
  Convert = 'convert',
  /** 不满足转报全阶要求 */
  NoConvert = 'no-convert',
  /** 我要报名 */
  Signup = 'signup',
  /** 即将报名 */
  NotStarted = 'not-started'
}

export enum EnumSupportType {
  /** 书童伴学 */
  Mate = 'mate',
  /** 助教评阅 */
  Teach = 'teach',
  /** IT支持 */
  IT = 'it',
  /** 暄桐文房 */
  Wenfang = 'wenfang'
}
